// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { categoriesRequested, categoriesRequestFailed, categoriesRequestSucceeded } from './select-category.actions';
import { CategoriesResponse } from '../models/category';

export const STATE_NAME = 'select-category';

export interface State {
  isLoading: boolean;
  isError: boolean;
  categoriesResponse?: CategoriesResponse;
}

const initialState: State = {
  isLoading: false,
  isError: false,
  categoriesResponse: undefined,
};

const reducer = createReducer(
  initialState,
  on(categoriesRequested, (state) => ({...state, isLoading: true, isError: false})),
  on(categoriesRequestSucceeded, (state, {categoriesResponse}) => ({...state, categoriesResponse, isLoading: false})),
  on(categoriesRequestFailed, (state) => ({...state, isLoading: false, isError: true})),
);

export function selectCategoryReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}
